import { useHostServices } from '../HostServices'

// If needed, the hasPaperDelivery logic can be moved into the places where it's used with AFG Customer from HostData

const useCustomer = (): {
  hasPaperDelivery: () => boolean
} => {
  const { hostData } = useHostServices()

  const hasPaperDelivery = (): boolean => {
    return (
      hostData.afgCustomer.data?.data?.meta.deliveryPreference ===
      'ONLINE_AND_PAPER'
    )
  }
  return { hasPaperDelivery }
}

export { useCustomer }
